require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./central-precinct-foot-patrol.json") })
        }
      }, "path---central-precinct-foot-patrol");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---central-precinct-foot-patrol!./.cache/json/central-precinct-foot-patrol.json
// module id = 849
// module chunks = 231608221292675